import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useContext, useEffect, useState } from 'react';
import { Badge } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import { useTranslation } from 'react-i18next';
import { LoginInfo } from '../App';
import ApiFetch from './ApiFetch';
import RegistOrLogin from './RegistOrLogin';
import * as RIcon from "react-icons/fa"

const Clap = (props) => {
    const {t,i18n} = useTranslation()
    const [iconValue,setState] = useState(false)
    // ログイン情報
    const {loginInfo,setLoginInfo} = useContext(LoginInfo)
    const [count,setCount] = useState(props.count || 0)
    const [formatted,setFormatted] = useState()

    function clap(){
        /*if(loginInfo.length == 0 || !loginInfo.result){
            props.dialog("エラー","拍手するにはログインする必要があります。")
            return
        }*/
        new ApiFetch().post(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/clap/"+props.type+"/"+props.id,{}).then((res) => {
            res.json().then((json)=>{
                if(json.result){
                    setCount(json.data.count)
                }
            })  
        })
    }

    useEffect(() => {
        setCount(props.count)
        //setFormatted(unit(props.count))
    },[props.count])

    function unit(){
        let str = ""
        let units = ["K","M"]
        let i = 0
        let c = count
        while(c >= 1000){
            c = c / 1000
            i++
        }
        if(i > 0){
            str = c + " " + units[i-1]
        } else {
            str = c
        }

        console.log(str)
        return str
    }
    return (
        <span style={props.style} onClick={() => clap()}>
            👏 <span style={{color:"#555555",display:count === 0 || count === -1 ? "none" : "inline"}}>{count}</span>
        </span>
    )
}

export default Clap;